/* tslint:disable:max-line-length */
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const XRayIconSquare = ({
  className,
  style: styleFromProps,
  onClick,
  size,
  color = '#262626',
}: IconTypeProps) => {
  const style = {
    ...styleFromProps,
    ...(size ? { width: size, height: size } : {}),
  };
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 5C7.24304 5 5 7.24304 5 10C5 12.757 7.24304 15 10 15C10.8792 15 11.7438 14.7687 12.5006 14.3308L11.875 13.2486C11.308 13.5767 10.6595 13.75 10 13.75C7.93214 13.75 6.24999 12.0679 6.24999 10C6.24999 7.93214 7.93214 6.24999 10 6.24999C12.0679 6.24999 13.75 7.93214 13.75 10V10.5444C13.75 10.9534 13.4873 11.25 13.125 11.25C12.7804 11.25 12.5 10.9695 12.5 10.625V8.125H11.636C11.1963 7.74089 10.6283 7.49999 10 7.49999C8.62152 7.49999 7.49999 8.62152 7.49999 10C7.49999 11.3785 8.62152 12.5 10 12.5C10.6564 12.5 11.2499 12.2404 11.6965 11.8251C12.0407 12.2342 12.5498 12.5 13.125 12.5C14.1763 12.5 15 11.641 15 10.5444V10C15 7.24304 12.757 5 10 5ZM10 11.25C9.3106 11.25 8.75001 10.6894 8.75001 10C8.75001 9.3106 9.31062 8.75001 10 8.75001C10.6894 8.75001 11.25 9.31062 11.25 10C11.25 10.6894 10.6894 11.25 10 11.25Z"
        fill={color}
      />
      <path
        d="M2.65039 6.33398H1.47852C1.39761 6.33398 1.33203 6.2684 1.33203 6.1875V1.48047C1.33203 1.39957 1.39761 1.33398 1.47852 1.33398H6.18555C6.26645 1.33398 6.33203 1.39957 6.33203 1.48047V2.65234C6.33203 2.73325 6.26645 2.79883 6.18555 2.79883H2.79688V6.1875C2.79688 6.2684 2.73129 6.33398 2.65039 6.33398Z"
        fill={color}
      />
      <path
        d="M13.6655 2.65234L13.6655 1.48047C13.6655 1.39957 13.7311 1.33398 13.812 1.33398L18.519 1.33398C18.5999 1.33398 18.6655 1.39957 18.6655 1.48047L18.6655 6.1875C18.6655 6.2684 18.5999 6.33398 18.519 6.33398L17.3472 6.33398C17.2663 6.33398 17.2007 6.2684 17.2007 6.1875L17.2007 2.79883L13.812 2.79883C13.7311 2.79883 13.6655 2.73325 13.6655 2.65234Z"
        fill={color}
      />
      <path
        d="M17.1588 13.667L18.4981 13.667C18.5906 13.667 18.6655 13.7326 18.6655 13.8135L18.6655 18.5205C18.6655 18.6014 18.5906 18.667 18.4981 18.667L13.1187 18.667C13.0262 18.667 12.9512 18.6014 12.9512 18.5205L12.9512 17.3486C12.9512 17.2677 13.0262 17.2021 13.1187 17.2021L16.9914 17.2021L16.9914 13.8135C16.9914 13.7326 17.0664 13.667 17.1588 13.667Z"
        fill={color}
      />
      <path
        d="M6.33203 17.3486L6.33203 18.5205C6.33203 18.6014 6.26645 18.667 6.18555 18.667L1.47852 18.667C1.39761 18.667 1.33203 18.6014 1.33203 18.5205L1.33203 13.8135C1.33203 13.7326 1.39761 13.667 1.47852 13.667L2.65039 13.667C2.73129 13.667 2.79688 13.7326 2.79688 13.8135L2.79688 17.2021L6.18555 17.2021C6.26645 17.2021 6.33203 17.2677 6.33203 17.3486Z"
        fill={color}
      />
    </svg>
  );
};
